import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import AllTerritories from "./components/AllTerritories";

import AccessDenied from "components/AccessDenied";
import PageContainer from "components/PageContainer";
import { useAuth } from "contexts/auth.context";
import Footer from "examples/Footer";
import { Route, Routes } from "react-router-dom";

function Territories() {
  const { checkPermission } = useAuth();

  if (
    Object.keys(checkPermission("territory")).filter(
      (key) => checkPermission("territory")[key]
    ).length === 0
  ) {
    return <AccessDenied type="page" />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <PageContainer>
        <Routes>
          <Route
            index
            element={
              <AllTerritories permissions={checkPermission("territory")} />
            }
          />
        </Routes>
      </PageContainer>

      <Footer />
    </DashboardLayout>
  );
}

export default Territories;
